import {isNil, isNotNil} from 'ramda';

import type {Money} from '@dms/api/shared';
import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

/**
 * Fills an unset leasing list price with the vehicle price.
 *
 * Apply it to both sides of a dirty diff. Defaulting only the edited body makes a persisted `null`
 * list price differ from its own prefilled form, which keeps the panel dirty for ever.
 */
export function applyDefaultLeasingListPrice(
  vehicleLeasingBody: SaveSaleVehicleLeasingBody,
  vehiclePrice: Money | Nullish
) {
  const hasListPrice = isNotNil(vehicleLeasingBody.commonParameters.listPrice);

  if (hasListPrice || isNil(vehiclePrice)) {
    return vehicleLeasingBody;
  }

  return {
    ...vehicleLeasingBody,
    commonParameters: {
      ...vehicleLeasingBody.commonParameters,
      listPrice: vehiclePrice,
    },
  };
}
